/**
 * Custom Drupal Form & Button Fixes
 */
(function ($, Drupal) {
  Drupal.behaviors.buttonGroupFixes = {
    attach: function (context) {
      // Remove mailto: from button labels
      $(context).find('.component-button-group__button').each(function () {
        const $link = $(this);
        
        // Find all text nodes inside the link
        $link.contents().filter(function() {
          return this.nodeType === 3; // nodeType 3 is a Text Node
        }).each(function() {
          if (this.nodeValue.includes('mailto:')) {
            // Update only the text, preserving surrounding HTML/SVG
            this.nodeValue = this.nodeValue.replace('mailto:', '');
          }
        });
      });

      $(context).find('.paragraph-type--button-email .form-item--linkit-widget-uri, .paragraph-type--button-email .field--name-field-button-group-link').each(function() {
        // Replace form field label with "Email"
        $(this).find('.fieldset__label').text('Email').hide();
        // Replace the form input label within .form-item--linkit-widget-uri with "Email"
        $(this).find('.form-item--linkit-widget-uri .form-item__label').text('Email');

        // Replace button title label with "button text"
        $(this).find('.form-item--linkit-widget-title .form-item__label').text('Button Text');
      });

    }};
})(jQuery, Drupal);
